import React from "react";
import useForm from "./index";
import Label from "./label";
import { TForm, TInputElementProps, TInputProps } from "./types";

export const StringInput = (props: TInputElementProps<TStringInput>) => {
    const { container, label, input, tooltip, className, hidden, options, style } = props;

    if (hidden) {
        return null;
    }

    return (
        <div {...container} className={container?.className ?? className} style={style}>
            <Label {...label} tooltip={tooltip} options={options}/>
            <input {...input}/>
        </div>
    );
}

type TStringInput = string;
const useStringInput = <T extends TStringInput>(props: TInputProps<T>): TForm<TStringInput> => {
    const form = useForm<TStringInput>({
        id: "string",
        default: "",
        ...props,
    })

    return {
        ...form,
    }
}

export default useStringInput;
